import request from 'superagent';

export function refreshCsrfToken() {
    return new Promise((resolve, reject) => {
        get('/start/csrf-meta').end((err, { body }) => {
            let meta = document.querySelector(`meta[name="${body.param}"]`);
            if (meta) {
                meta.content = body.token;
            } else {
                meta = document.createElement('meta');
                meta.name = body.param;
                meta.content = body.token;
                meta = document.querySelector('head').appendChild(meta);
            }

            resolve();
        });
    })
}

export function csrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) {
        return token.content;
    } else {
        return null;
    }
}

export function post(url, data) {
    return request
        .post(url)
        .send(data)
        .set('Accept', 'application/json')
        .set('X-CSRF-Token', csrfToken());
}

export function get(url) {
    return request
        .get(url)
        .set('Accept', 'application/json');
}



/** WEBPACK FOOTER **
 ** ./js/common/utils/xhr.js
 **/